module.exports = __webpack_public_path__ + "img/production.0368fa0a.png";